 
//export const base_url = 'https://alhudademo.integratesolu.com/';
//export const base_url = 'http://localhost:3000/';
export const base_url = 'https://alhudabutchery.com/';
//export const api_base_url = 'https://alhuda.integratesolu.com/public/api/';
export const api_base_url = 'https://admin.alhudabutchery.com/public/api/';
export const web_base_url = 'https://admin.alhudabutchery.com/public/';
export const Stripe_Code = 'pk_live_51QWyNq02BwVYcXbdMYXXxKYKYMTVGsESj3KMvvqfClQeLj7I628ZnTRArO72CneIR8WHz3RB91bfIfNgacbTbjQp00Et33ceds';
//export const Stripe_Code = 'pk_test_51QWyNq02BwVYcXbd9SqTnIVA35w2mpKzlceHklF4oBeHpMSJVd1ufjDRGq9cHo8zVVafWiZC2GvIwoXQsKwUhRt200qnzMTNj6';